export default {
    ActionTypes: {

    },
    Engine: {
        STOP_PREDICTING_LAPSE: 300,
        MAX_BET: 100000000 /** Max bet per game 1,000,000 Bits, this will be calculated dynamically in the future, based on the invested amount in the casino **/
    },
    // Animations: {
    //     NYAN_CAT_TRIGGER_MS: 115129 //115129ms ~ 1000x // 11552ms ~ 2x
    // },
    BetButton: {
        INITIAL_DISABLE_TIME: 500 //The time the button is disabled after cashing out and after the game crashes
    },
};
